import { createRef } from 'react'
import { create } from 'zustand'

const useMessagesStore = create((set) => ({
    replyingToMessage: undefined,
    editingMessage: undefined,
    inputRef: createRef(),
    messageForReaction: {},
    highlightedMessageID: undefined,
    scrollToMessageCallback: undefined,
    setReplyingToMessage: (replyingToMessage) => set(() => ({ replyingToMessage, editingMessage: undefined })),
    setEditingMessage: (editingMessage) => set(() => ({ editingMessage, replyingToMessage: undefined })),
    setInputRef: (inputRef) => set(() => ({ inputRef })),
    setMessageForReaction: (message) => set((state) => ({ messageForReaction: typeof message === 'function' ? message(state.messageForReaction) : message })),
    setHighlightedMessageID: (highlightedMessageID) => set(() => ({ highlightedMessageID })),
    setScrollToMessageCallback: (scrollToMessageCallback) => set(() => ({ scrollToMessageCallback })),
}))

export default useMessagesStore